import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function NoResults({ results, additionalData }: componentTypes.NoResultsProps) {
  const hasRefinements = results.getRefinements().length > 0;
  const { search } = additionalData;

  return (
    <div className="bg-white flex flex-col gap-16 items-start justify-start relative w-full not-first:pt-8 not-last:pb-8 not-last:border-b not-last:border-gray-950/10">
      <div className="flex flex-col gap-3 items-start justify-start relative w-full">
        <div className="flex flex-col justify-center not-italic relative">
          <h3 className="font-secondary font-bold text-2xl text-green-500 theme-contrast:text-gray-950 leading-title">{Craft.t(search, "Sorry, we can't find any matches to your query!")}</h3>
        </div>
        <div className="flex flex-col items-start justify-start not-italic relative w-full">
          <div className="flex-col justify-center min-w-full overflow-ellipsis overflow-hidden relative text-gray-900 text-base font-normal">
            <p>{hasRefinements
              ? Craft.t(search, 'Try to reset your applied filters.')
              : Craft.t(search, "Please try another query.")
            }</p>
          </div>
        </div>
      </div>
    </div>
  );
}
